// extracted by mini-css-extract-plugin
export default {"container":"StoryFramesSequence_container__svtDF","storyImage":"StoryFramesSequence_storyImage__N6ZLw","textContainer":"StoryFramesSequence_textContainer__EOZuA"};